import { FC, PropsWithChildren, createContext, useState } from 'react';
import { useRouter } from 'next/router';
import { PlayerMeta } from '../types';
import { useIsEmbedded } from './MPEmbeddedContextProvider';
interface SpectatorViewContextProps {
  assumedUserFilter: string;
  assumedUser?: PlayerMeta;
  setAssumedUser?: (selectedOption: PlayerMeta) => void;
  reset?: () => void;
}
export const SpectatorViewContext = createContext({} as SpectatorViewContextProps);
const ASSUMED_USER_KEY = 'assumedUser';
const readInitialAssumedUser = (): PlayerMeta | undefined => {
  if (typeof window === 'undefined') return undefined;
  try {
    const raw = window.sessionStorage.getItem(ASSUMED_USER_KEY);
    return raw ? JSON.parse(raw) as PlayerMeta : undefined;
  } catch {
    return undefined;
  }
};
export const SpectatorViewProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const router = useRouter();
  const {
    isEmbedded
  } = useIsEmbedded();
  const [user, setUser] = useState<PlayerMeta | undefined>(readInitialAssumedUser);
  const effectiveUser = isEmbedded ? undefined : user;
  const filter = effectiveUser ? `assumed_user_id=${effectiveUser.id.toString()}` : '';
  const value = {
    assumedUser: effectiveUser,
    assumedUserFilter: filter,
    setAssumedUser: selectedUser => {
      if (router.pathname === '/games/[id]') {
        router.push({
          pathname: '/games'
        }).catch(err => console.error(err));
      }
      setUser(selectedUser);
      if (!isEmbedded && typeof window !== 'undefined') {
        window.sessionStorage.setItem(ASSUMED_USER_KEY, JSON.stringify(selectedUser));
      }
    },
    reset: () => {
      if (router.pathname === '/games/[id]') {
        router.push({
          pathname: '/games'
        }).catch(err => console.error(err));
      }
      setUser(undefined);
      if (!isEmbedded && typeof window !== 'undefined') {
        window.sessionStorage.removeItem(ASSUMED_USER_KEY);
      }
    }
  };
  return <SpectatorViewContext.Provider value={value} data-sentry-element="unknown" data-sentry-component="SpectatorViewProvider" data-sentry-source-file="SpectatorViewProvider.tsx">
      {children}
    </SpectatorViewContext.Provider>;
};